import { Component, OnInit } from '@angular/core'

@Component({
  selector: 'app-register-master-agent',
  templateUrl: './register-master-agent.component.html',
  styleUrls: ['./register-master-agent.component.scss'],
})
export class RegisterMasterAgentComponent {}
